export const SHOW_LOADING = "SHOW_LOADING";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";

export const SHOW_TOAST = "SHOW_TOAST";

export const GET_CHAPTER_DATA = "GET_CHAPTER_DATA"
export const GET_SINGLE_CHAPTER = "GET_SINGLE_CHAPTER"
export const ADD_CHAPTER = "ADD_CHAPTER"
export const DELETE_CHAPTER = "DELETE_CHAPTER"
export const EDIT_CHAPTER = "EDIT_CHAPTER"

export const ADD_LESSON = "ADD_LESSON"
export const DELETE_LESSON_DATA = "DELETE_LESSON_DATA"
export const EDIT_LESSON_DATA = "EDIT_LESSON_DATA"
export const GET_SINGLE_LESSON = "GET_SINGLE_LESSON"
export const REPLACE_LESSON_DATA = "REPLACE_LESSON_DATA"

export const GET_CONTENT_DATA = "GET_CONTENT_DATA"
export const ADD_INTRO = "ADD_INTRO"
export const GET_INTRO_DATA = "GET_INTRO_DATA"
export const DELETE_INTRO = "DELETE_INTRO"
export const ADD_SAMPLE = "ADD_SAMPLE"
export const EDIT_SAMPLE = "EDIT_SAMPLE"
export const EDIT_EBOOK = "EDIT_EBOOK"
export const DELETE_SAMPLE = "DELETE_SAMPLE"
export const GET_SAMPLE_DATA = "GET_SAMPLE_DATA"
export const EDIT_CONTENT = "EDIT_CONTENT"
export const GET_SINGLE_SAMPLE = "GET_SINGLE_SAMPLE"
export const EDIT_SAMPLE_PIC = "EDIT_SAMPLE_PIC"

export const GET_LESSON_DATA = "GET_LESSON_DATA"
export const GET_LESSONS_DATA = "GET_LESSONS_DATA"

export const GET_SUB_DATA = "GET_SUB_DATA"
export const GET_SUB_SINGLE = "GET_SUB_SINGLE"
export const DELETE_PLAN = "DELETE_PLAN"
export const ADD_PLAN = "ADD_PLAN"
export const EDIT_PLAN = "EDIT_PLAN"

export const GET_USER_DATA = "GET_USER_DATA"
export const GET_USER_COUNT = "GET_USER_COUNT"
export const GET_USER = "GET_USER"
export const DELETE_USER_DATA = "DELETE_USER_DATA"
export const ASSIGNED_USER = "ASSIGNED_USER"

export const GET_ADMIN_DATA = "GET_ADMIN_DATA"
export const CHANGE_ADMIN_PASSWORD = "CHANGE_ADMIN_PASSWORD"

export const GET_PARTNER_DATA = "GET_PARTNER_DATA"
export const GET_GUIDE_DATA = "GET_GUIDE_DATA"
export const DELETE_GUIDE = "DELETE_GUIDE"
export const ADD_GUIDE = "ADD_GUIDE"
export const ADD_PARTNER = "ADD_PARTNER"
export const GET_SINGLE_GUIDE = "GET_SINGLE_GUIDE"
export const GET_SINGLE_PARTNER = "GET_SINGLE_PARTNER"
export const EDIT_PARTNER = "EDIT_PARTNER"
export const EDIT_GUIDE = "EDIT_GUIDE"
export const SPOTLIGHT_GUIDE = "SPOTLIGHT_GUIDE"
export const DELETE_PARTNER = "DELETE_PARTNER"
export const SPOTLIGHT_PARTNER = "SPOTLIGHT_PARTNER"

export const ADD_TRIGER = "ADD_TRIGER"
export const EDIT_SAMPLE_TRIGGER = "EDIT_SAMPLE_TRIGGER"
export const DELETE_TRIGGER = "DELETE_TRIGGER"
export const DELETE_SAMPLE_TRIGGER = "DELETE_SAMPLE_TRIGGER"
export const GET_TRIGGER_DATA = "GET_TRIGGER_DATA"
export const GET_SAMPLE_TRIGGER_DATA = "GET_SAMPLE_TRIGGER_DATA"
export const GET_SINGLE_TRIGGER = "GET_SINGLE_TRIGGER"
export const EDIT_TRIGGER = "EDIT_TRIGGER"


export const ADD_COACH = "ADD_COACH"
export const GET_ALL_COACHES = "GET_ALL_COACHES"
export const GET_FAV_LESSON = "GET_FAV_LESSON"
export const DELETE_COACH = "DELETE_COACH"
export const DRAG_DATA = "DRAG_DATA"
export const DRAG_SAMPLE_DATA = "DRAG_SAMPLE_DATA"
export const DRAG_LESSON_DATA = "DRAG_LESSON_DATA"
export const DRAG_SAMPLELESSON_DATA = "DRAG_SAMPLELESSON_DATA"
export const INTERCOME_TEAM_DATA = "INTERCOME_TEAM_DATA"

export const DRAG_COACH = "DRAG_COACH"